
export const AGORA_APP_ID = 'ace6a1e6ba354c498d806c663e21b470';

export const SHARE_LINK_MESSAGE = "The room link was copied to the clipboard";
